module.exports = __webpack_public_path__ + "img/008王晓东.5c662200.jpg";